(function (window, document, $) {

    $(document).ready(function () {
        // Sticky menus ================================================================================================

        var $stickies = $('[data-sticky]');

        $(window).scroll(function (e) {

            var pageOffset = window.pageYOffset;

            $stickies.filter('[data-sticky!="false"]').each(function (index, el) {

                var $el = $(el),
                    elOffset = el.offsetTop,
                    elHeight = $el.height(),
                    stickySection = $el.parents('section').first(),
                    $stickySection = $(stickySection),
                    stickyStart = $stickySection.offset().top,
                    stickyEnd = stickyStart + $stickySection.height(),
                    isSticky = $el.hasClass('is-sticky'),
                    fixedBottom = $el.hasClass('fixed-bottom');


                switch (true) {

                    case (pageOffset >= stickyStart) && pageOffset <= stickyEnd:
                        $el
                            .addClass('is-sticky')
                            .removeClass('fixed-bottom');
                        $stickySection
                            .addClass('has-sticky')
                            .css('padding-top', elHeight + 'px')
                            .css('padding-bottom', 0);
                        break;

                    case pageOffset < stickyStart:
                        $el
                            .removeClass('is-sticky')
                            .removeClass('fixed-bottom');
                        $stickySection
                            .removeClass('has-sticky')
                            .css('padding-top', 0)
                            .css('padding-bottom', 0);
                        break;

                    case pageOffset > stickyEnd:
                        $el
                            .removeClass('is-sticky')
                            .addClass('fixed-bottom');
                        $stickySection
                            .removeClass('has-sticky')
                            .css('padding-top', 0)
                            .css('padding-bottom', elHeight + 'px');
                        break;

                    case pageOffset >= elOffset && pageOffset > stickyStart:
                        $el
                            .addClass('is-sticky')
                            .removeClass('fixed-bottom');
                        $stickySection
                            .addClass('has-sticky')
                            .css({
                                'padding-top': elHeight,
                                'padding-bottom': 0
                            });
                        break;
                }
            });
        });

    });

}(window, document, jQuery));
